import React from "react";
import Maim from "./Maim/Maim";
import HAbout from "./HAbout2";
import AboutCard2 from "../about/AboutCard2";
import Header from "../../components/common/header/Header";
import Footer2 from "../common/footer/Footer2";

const Homes = () => {
  return (
    <>
{/* <Header/> */}
      <Maim  />
      <AboutCard2 />
      <HAbout />
        <Footer2/>
    </>
  );
};

export default Homes;
